import React from "react";
import { Box } from "@mui/material";
import Hero from "./Home/Hero";
import Features from "./Home/Features";
import Pricing from "./Home/Pricing";
import Signup from "./Home/SignUp";
import { useTheme } from "@mui/material/styles";
import TheProblem from "./Home/TheProblem";
import TheTargetAudience from "./Home/TheTargetAudience";

const Home = () => {

  const theme = useTheme();
  
  return (
    <Box
      sx={{
        background: theme.palette.background.default, //"#0f172a",
        color: theme.palette.text.primary, //"#ffffff",
      }}
    >
      <Hero />
      <TheProblem />
      <TheTargetAudience />
      <Features />
      {/* <Pricing /> */}
      <Signup />
    </Box>
  );
};

export default Home;
